import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost } from '../../../../utils/AxiosUtil';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../common/inputfields/NewAgainField';

class NewCategory extends Component {

    state = {
        newAgain: false,
        name: '',
        comment: '',
        errors: new Map(),
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            name: '',
            comment: '',
            errors: new Map(),
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/category';
        const requestObject = {
            "name": this.state.name,
            "comment": this.state.comment,
        };
        await handlePost(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="name"
                            label="Megnevezés"
                            errors={this.state.errors}
                            value={this.state.name}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            errors={this.state.errors}
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewCategory);
